import {
  collectNodeSourceOptions,
  NodeSourceOption,
} from '../../networkNodeCopyUtils';
import {
  createDefaultRole,
  DepartmentFormValues,
  NetworkNodeFieldPath,
  NetworkNodeFormValues,
  RoleFormValues,
} from '../../../types';

export type RoleSourceOption = NodeSourceOption;

export const isFilledRole = (r: RoleFormValues) =>
  Boolean(
    r.departmentId &&
    r.color &&
    r.icon &&
    r.roleType &&
    r.permissionLevel &&
    r.permissions?.length > 0,
  );

const getFilledRoles = (roles: RoleFormValues[] = []) =>
  roles.filter(isFilledRole);

export function collectRoleSourceOptions(
  network: NetworkNodeFormValues[],
  currentPath: NetworkNodeFieldPath,
): RoleSourceOption[] {
  return collectNodeSourceOptions(
    network,
    currentPath,
    node => node.roles ?? [],
    items => getFilledRoles(items).length > 0,
  );
}

export function cloneRolesFromSource(
  sourceRoles: RoleFormValues[],
  sourceDepartments: DepartmentFormValues[],
  targetDepartments: DepartmentFormValues[],
): RoleFormValues[] {
  const sourceDeptIdToName = new Map(
    sourceDepartments.map(d => [d.id, d.name.trim()]),
  );

  const targetNameToDeptId = new Map(
    targetDepartments
      .filter(d => d.name?.trim())
      .map(d => [d.name.trim(), d.id]),
  );

  return getFilledRoles(sourceRoles).map(role => {
    const sourceDeptName = sourceDeptIdToName.get(role.departmentId)?.trim();
    const targetDeptId = sourceDeptName
      ? (targetNameToDeptId.get(sourceDeptName) ?? '')
      : '';

    return createDefaultRole(targetDeptId, {
      color: role.color,
      icon: role.icon,
      roleType: role.roleType,
      permissionLevel: role.permissionLevel,
      customPermission: role.customPermission,
      permissions: [...role.permissions],
    });
  });
}
